/*
    Adds Read More functionality to the auto comparison table on the product page. 
    This table is generated by the Equate - Product Compare app.
    [https://admin.shopify.com/store/intelligent-hand-dryers/apps/product-compare/compare_product/v2/admin/index.php]

    The css for this functionality is contained in the product-page.css file under 
    the heading "Compare Table Read More".,
*/

window.addEventListener("load", function () {
    const compareTableContainer = this.document.querySelector(".sp-comp-main");

    if (compareTableContainer == undefined) {
        return;
    }

    const readMoreDiv = document.createElement("div");
    readMoreDiv.innerHTML = '<button class="btn btn--secondary" data-read-more>Read More</button>';
    readMoreDiv.className = "read-more";
    compareTableContainer.appendChild(readMoreDiv);

    readMoreDiv.querySelector('button').addEventListener("click", (e) => {
        e.target.parentElement.parentElement.classList.add("show");
    });
});
